import React from "react";
import "../../payment/info/PaymentInfo.css";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import TestIndicator from "../../common/TestIndicator";

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: palette.primary.contrastText,
    background: `linear-gradient(36deg, ${palette.primary.dark} 0%, ${palette.primary.main} 54%, ${palette.primary.light} 100%)`,
    padding: "25px",
    alignItems: "center",
    display: "flex",
    position: "relative",
    fontSize: "1.15rem"
  }
}));

const getLogo = charge => {
  const { theme } = charge || {};
  return (
    (theme && theme.logo) ||
    (window.location.hostname.indexOf("lyra") < 0 &&
      theme &&
      theme.domainName &&
      "alt_default") ||
    "default"
  );
};

const RecurringHeader = ({ recurring }) => {
  const classes = useStyles();
  const { plan = {} } = recurring;

  const { type } = plan;
  return (
    <div className={classes.root}>
      <div className="shop-logo-container">
        {getLogo(recurring) === "alt_default" ? (
          <img
            src={`/images/error-logos/${recurring.theme?.domainName?.image}_logo.png`}
            alt="Logo"
          />
        ) : (
          <img src={`/static/shop-logo/${getLogo(recurring)}`} alt="Logo" />
        )}
      </div>
      <div style={{ minWidth: "200px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="shopName">{recurring?.shopName || "Shop Name"}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="orderId">{recurring?.orderId || "Order ID"}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div id="orderId">{`E-Mandate - ${type}`}</div>
        </div>
        {recurring.testMode && <TestIndicator />}
      </div>
    </div>
  );
};

RecurringHeader.propTypes = {
  recurring: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    displayAmount: PropTypes.number.isRequired,
    initialAmount: PropTypes.string,
    shopId: PropTypes.string.isRequired,
    shopName: PropTypes.string.isRequired,
    shopLogoId: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    testMode: PropTypes.bool.isRequired,
    plan: PropTypes.shape({
      type: PropTypes.string.isRequired
    }).isRequired,
    theme: PropTypes.shape({
      domainName: PropTypes.shape({
        image: PropTypes.string
      })
    }).isRequired
  }).isRequired
};

export default RecurringHeader;
